import { AlertService } from '@/common/services/alert/alert.service';
import { CurrentReservationService } from '@/common/services/reservation/current';
import { ValidationService } from '@/common/services/validation/validation.service';
import { SuscribeEmailUseCase } from '@/core/domain/newsletter/usecases/suscribeEmail.usecase';
import { Promotion } from '@/core/domain/promotions/models/promotions-reponse.model';
import { GetPromotionsUseCase } from '@/core/domain/promotions/usecases/getPromotions.usecase';
import { InputComponent } from '@/ui/shared/ui/input/input.component';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { catchError } from 'rxjs';
import { throwError } from 'rxjs/internal/observable/throwError';

@Component({
    selector: 'fe-promotions',
    templateUrl: './promotions.component.html',
    styleUrls: ['./promotions.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class PromotionsComponent implements OnInit {
    public promotion: Promotion | null = null;
    public newsLetterForm!: FormGroup;
    public value = '';
    public loadingBtnSearch = false;
    public suscribed = false;

    @ViewChild('email') email!: InputComponent;

    constructor(
        private readonly getPromotionsUsecase: GetPromotionsUseCase,
        private fb: FormBuilder,
        private readonly validation: ValidationService,
        private readonly suscribeEmailUseCase: SuscribeEmailUseCase,
        private readonly alert: AlertService,
        private readonly reservation: CurrentReservationService,
        private readonly meta: Meta,
        private readonly titleService: Title,
    ) {}

    ngOnInit(): void {
        this.getPromotionsUsecase.execute().subscribe({
            next: (response) => {
                const promotions: Promotion[] =
                    response?.data?.promotions ?? [];
                this.promotion =
                    promotions.find((promotion) => promotion.seccionPromo) ??
                    null;
                this.reservation.current.discountCode =
                    this.promotion?.code ?? null;
                this.updateMetaTags();
            },
            error: () => {
                this.promotion = null;
            },
        });

        this.newsLetterForm = this.fb.group({
            email: [
                '',
                Validators.compose([
                    Validators.required,
                    this.validation.validEmail,
                ]),
            ],
        });
    }

    private updateMetaTags(): void {
        if (this.promotion?.name) {
            this.titleService.setTitle(this.promotion.name);
            this.meta.updateTag({
                name: 'title',
                content: this.promotion.name,
            });
        }
        if (this.promotion?.subTitle) {
            this.meta.updateTag({
                name: 'description',
                content: this.promotion.subTitle,
            });
        }
    }

    onclickSuscribe() {
        if (!this.newsLetterForm.valid) {
            return;
        }

        this.value = this.newsLetterForm.get('email')?.value;
        this.loadingBtnSearch = true;

        this.suscribeEmailUseCase
            .execute(this.value)
            .pipe(
                catchError((error) => {
                    this.loadingBtnSearch = false;
                    this.alert.openDefault(error);
                    return throwError(() => error);
                }),
            )
            .subscribe((success) => {
                if (success.data.status === 'subscribed') {
                    this.loadingBtnSearch = false;
                    this.suscribed = true;
                }
            });
    }
}
